module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h10"
  }, [_c('a', {
    attrs: {
      "id": "a12"
    }
  }), _vm._v("Chapter 1: Paula’s Problem")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“I wish I didn’t have to go away over Christmas "), _c('span', {
    staticClass: "t5"
  }, [_vm._v("again")]), _vm._v("” Paula moaned. “If only I had a brother or sister to go in my place!”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Her friend Melissa sympathized. “I never thought I’d say how lucky I am to have siblings—or parents who live nearby!”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("It was Saturday in mid-December. They were brushing their horses in neighboring stalls, after taking advantage of the welcome sunshine to ride around the rural property of Farthing Boarding Stables.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("The issue under discussion was the fact that something badly upset Paula’s mare every Christmas. But her owner was never here to find the cause, being expected to fly to her parents’ house three states away.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“If only I could convince them to come here,” she said with feeling, brushing her little chestnut’s flanks so hard that the mare turned her head round with ears pinned back to tell Paula that was too much. “Sorry, girl! I’m taking out my frustration on you.” She gave the horse a treat then stroked her face. Mollified, Peppi returned to ripping strands of hay out of her small hole net.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Still holding the body brush, Paula leaned across her animal’s broad back and sighed. “As much as Peppi’s colics have cost me in vets’ bills over the years, I could have had her shipped to a barn near my parents’ place every Christmas!”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Although her accounting job paid well, these costs were really hard to take. Thankfully she had colic insurance, which she could claim on if Peppi ever needed an operation. But she’d like to make sure it never came to that.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Though how could she, when she didn’t even know what stressed Peppi out so much? And how was she going to know, if she was never around to find out?")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Mr. and Mrs. Newton had already called to find out when their daughter planned to be at their house for Christmas. She’d been sorely tempted to tell them she couldn’t afford the trip this year. But she knew what accusations would be hurled over the phone if she dared suggest such a thing:")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“You mean your horse"), _c('span', {
    staticClass: "t5"
  }), _vm._v("means more to you than your family?” (Well, "), _c('span', {
    staticClass: "t5"
  }, [_vm._v("duh")]), _vm._v("!)")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“You don’t know how much longer we’ll be around. You’ll regret it if you don’t see us at least once a year!” (My horse might not make it through Christmas and I’ll really regret leaving "), _c('span', {
    staticClass: "t5"
  }, [_vm._v("her")]), _vm._v("!)")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Paula was stuck between a rock and a hard place. She loved her parents, "), _c('span', {
    staticClass: "t5"
  }, [_vm._v("but")]), _vm._v("…")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05107d20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005.vue
// module id = 66
// module chunks = 0